module.exports = __webpack_public_path__ + "e292206317a294c2cded688873a5c6a6.svg";